export const uniqueNonSecureId = () => Date.now().toString(36);
